@if (hasContent) {
	<details class="rea-technical-details">
		<summary>{{ title }}</summary>

		@if (details.length > 0) {
			<div class="rea-technical-details__grid">
				@for (detail of details; track detail.label + ':' + detail.value) {
					<span><b>{{ detail.label }}:</b> {{ detail.value }}</span>
				}
			</div>
		}

		@if (visibleMetrics.length > 0) {
			<div class="rea-metrics rea-metrics--compact">
				@for (metric of visibleMetrics; track metric.label) {
					<div class="rea-metric">
						<span class="rea-metric__value">{{ metric.value }}</span>
						<span class="rea-metric__label">{{ metric.label }}</span>
					</div>
				}
			</div>
		}
	</details>
}
